import BottomCard from './BottomCard';

export default BottomCard;
